import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "text-center mb-4" }
const _hoisted_2 = {
  key: 0,
  class: "hl-banner mb-5"
}
const _hoisted_3 = { class: "skin-page-heading" }
const _hoisted_4 = {
  key: 1,
  class: "col-sm-6 mx-auto"
}

import { computed } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderBanner',
  props: {
    title: { default: "" },
    subTitle: { default: "" }
},
  setup(__props) {

const props = __props;

const store = useStore();

const showBanner = computed<boolean>(() => store.state.configuration.guiidePlusShowHeaderBanner);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    (showBanner.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[0] || (_cache[0] = [
          _createElementVNode("p", null, "Read the information below or call us on 0117 314 1798 to find out more and have your questions answered by a specialist.", -1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("h2", _hoisted_3, _toDisplayString(__props.title), 1),
    (__props.subTitle)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_4, _toDisplayString(__props.subTitle), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})